module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_9006.d76a442f.png";